module.exports = __webpack_public_path__ + "img/hospital-walls.5a1bce00.svg";